import React from "react";
import { connect } from "react-redux";

import { isClubsReady } from "state/school_money/selectors";
import { markStudentClubBookingsAsSeen } from "state/school_money/actions";

import MaintainValidStudentID from "components/school_money/MaintainValidStudentID";
import Preloader from "components/school_money/Preloader";
import StudentSelector from "components/school_money/StudentSelector";
import StudentCarousel from "components/school_money/StudentCarousel";
import StudentClubBookingList from "components/school_money/clubs/StudentClubBookingList";

import "./ClubsPage.css";

class ClubsPage extends React.Component {

  isPageReady = state => {
    return isClubsReady(state, this.props.match.params.studentID);
  }

  generatePath = studentID => {
    return `/school_money/clubs/${studentID}/`;
  }

  onStudentChange = (studentID, prevStudentID) => {
    this.props.markStudentClubBookingsAsSeen(prevStudentID);
    this.clearFocus();
  }

  componentWillUnmount() {
    this.props.markStudentClubBookingsAsSeen(this.props.match.params.studentID);
  }

  // ---------------------------------------------------------------------------
  // Clear focus is nescessary to turn off focus on dropdown menus when the
  // student is changed. At present changing the focus of the page to a div
  // element corrects this problem (IOS).
  // ---------------------------------------------------------------------------
  clearFocus() {

     // Get the first clubs-page element, should only be one.
     let dinnerPageElement = document.getElementsByClassName("clubs-page")[0];

     // Catch error when element is missing, do not continue;
     if(dinnerPageElement === undefined){return;}

     // To be able to focus on a div element we need to add a tabindex.
     dinnerPageElement.tabIndex = -1;
     dinnerPageElement.focus();
  }

  render() {
    const { studentID } = this.props.match.params;
    return (
      <MaintainValidStudentID currentStudentID={studentID} generatePath={this.generatePath}>
        <Preloader isPageReady={this.isPageReady}>
          <div className="clubs-page">
            <div className="page-header">
              <h1 className="page-header__title">Clubs</h1>
              <StudentSelector selectedStudentID={studentID} generatePath={this.generatePath} />
            </div>
            <StudentCarousel activeStudentID={studentID} generatePath={this.generatePath} onChange={this.onStudentChange}>
              { studentID => <StudentClubBookingList key={studentID} studentID={studentID} /> }
            </StudentCarousel>
          </div>
        </Preloader>
      </MaintainValidStudentID>
    )
  }

}

export default connect(
  undefined,
  { markStudentClubBookingsAsSeen }
)(ClubsPage);



// WEBPACK FOOTER //
// ./src/components/school_money/clubs/ClubsPage.js